export const Exterior = {
  pdf: {
    text: 'See the printable reference tool.',
    link: 'https://file.kbb.com/kbb/images/ico/conditionRedesign/exterior/20180719ConditionTool.pdf',
  },
  title: 'Examples of Wear or Damage',
  content: [
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/exterior/dings.png',
      title: 'Ding',
      text: 'A surface indent smaller than a square post-it note (less than 4") with no creases or broken paint.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/exterior/minor-scratches.png',
      title: 'Minor Scratches or Paint Marks',
      text: 'Surface damage of any size that doesn’t expose bare metal.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/exterior/major-scratches.png',
      title: 'Major Scratches or Paint Chips',
      text: 'Damage that exposes bare metal, regardless of length.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/exterior/minor-dents.png',
      title: 'Minor Dent',
      text: 'A shallow indent smaller than a square post-it note (less than 4 inches) with visible hard creases or broken paint.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/exterior/major-dents.png',
      title: 'Major Dent or Rust',
      text: 'A deep indent larger than a post-it note (more than 4 inches) with visible hard creases and/or broken paint. A major dent may require replacement and may or may not include rust.',
    },
    {
      title: 'Previous Paint Work',
      text: 'Paint applied to cover surface damage such as fading, peeling, chalking, or cracking.',
    },
    {
      title: 'Previous Body Work',
      text: 'Vehicle panels fixed from dents, major scratches, or severe damage, whether caused by accidents or everyday use.',
    },
    {
      title: 'Replaced Parts',
      text: 'Original vehicle parts that were replaced due to irreparable damage.',
    },
    {
      title: 'Molding/Trim',
      text: 'Metal or plastic trim used to cover transitions between the car body and its other parts; usually found around windows and doors.',
    },
  ],
}
